module.exports = __webpack_public_path__ + "img/beiantu.d0289dc0.png";